import { FiChevronDown } from 'react-icons/fi'

import { type Filters, useMapContext } from '../MapContext'

interface GatewayFilterProps {
  onSelect: () => void
}

const options: { value: Filters['gateway']; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: 'online', label: 'Online' },
  { value: 'offline', label: 'Offline' },
]

export const GatewayFilter = ({ onSelect }: GatewayFilterProps) => {
  const { filters, setFilters } = useMapContext()

  const handleChange = (value: string) => {
    setFilters({ ...filters, gateway: value as Filters['gateway'] })
    onSelect()
  }

  const currentLabel = options.find((o) => o.value === filters.gateway)?.label ?? 'All'

  const DesktopContent = () => (
    <div className="dropdown hidden md:block" data-filter-dropdown>
      <div
        tabIndex={0}
        role="button"
        className="btn btn-sm btn-outline min-w-[135px] flex items-center justify-between font-normal"
      >
        <span>Gateway: {currentLabel}</span>
        <FiChevronDown className="w-4 h-4 text-base-content/60" />
      </div>
      <ul
        tabIndex={0}
        className="dropdown-content menu bg-base-100 rounded-lg shadow-lg border border-base-300 z-20 w-full p-1 mt-1"
      >
        {options.map((opt) => (
          <li key={opt.value}>
            <button
              onClick={() => handleChange(opt.value)}
              className={`text-xs ${filters.gateway === opt.value ? 'active' : ''}`}
            >
              Gateway: {opt.label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  )

  const MobileContent = () => (
    <div className=" md:hidden flex flex-col gap-2">
      <label className="text-base"> Gateway </label>
      <div className="flex gap-2">
        {options.map((opt) => (
          <button
            key={opt.value}
            onClick={() => handleChange(opt.value)}
            className={`btn btn-sm rounded-full px-6 flex-1 ${filters.gateway === opt.value ? 'btn-primary' : 'btn-outline'}`}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  )

  return (
    <>
      <DesktopContent />
      <MobileContent />
    </>
  )
}
